declare var $: any;

export default class TemperatureRange {
  private slider: any;

  private $minimumInput: HTMLInputElement;
  private $maximumInput: HTMLInputElement;

  private $minimumLabel: HTMLElement;
  private $maximumLabel: HTMLElement;

  constructor() {
    this.$minimumInput = document.querySelector('.tc-temperature-range__minimum');
    this.$maximumInput = document.querySelector('.tc-temperature-range__maximum');

    this.$minimumLabel = document.querySelector('.tc-temperature-range__values__minimum span');
    this.$maximumLabel = document.querySelector('.tc-temperature-range__values__maximum span');

    this.slider = $('.tc-temperature-range__slider').slider({
      tooltip: 'hide',
      value: [
        parseInt(this.$minimumInput.value),
        parseInt(this.$maximumInput.value),
      ],
    });

    this.slider.on('change', (event) => this.onSliderChange(event));

    this.$minimumInput.addEventListener('keyup', (event) => this.onInputChange(event));
    this.$maximumInput.addEventListener('keyup', (event) => this.onInputChange(event));

    this.$minimumInput.addEventListener('blur', (event) => this.onInputBlur(event));
    this.$maximumInput.addEventListener('blur', (event) => this.onInputBlur(event));

    this.updateLabels();
  }

  private onSliderChange(event): void {
    this.$minimumInput.value = event.value.newValue[0];
    this.$maximumInput.value = event.value.newValue[1];

    this.updateLabels();
  }

  private onInputChange(event): void {
    this.slider.slider('setValue', [
      parseFloat(this.$minimumInput.value.replace(',', '.')),
      parseFloat(this.$maximumInput.value.replace(',', '.')),
    ]);

    this.updateLabels();
  }

  private onInputBlur(event): void {
    const minimumValue = this.$minimumInput.value.replace(',', '.');
    const maximumValue = this.$maximumInput.value.replace(',', '.');

    let minimum = parseFloat(minimumValue);
    let maximum = parseFloat(maximumValue);

    if (minimum > maximum || maximum < minimum) {
      this.$minimumInput.value = maximumValue;
      this.$maximumInput.value = minimumValue;

      minimum = maximum;
      maximum = parseFloat(minimumValue);
    }

    if (minimum < -30) {
      this.$minimumInput.value = '-30';
    } else if (!this.$minimumInput.value.length) {
      this.$minimumInput.value = '0';
    }

    if (maximum > 70) {
      this.$maximumInput.value = '70';
    } else if (!this.$maximumInput.value.length) {
      this.$maximumInput.value = '0';
    }

    this.slider.slider('setValue', [
      parseFloat(this.$minimumInput.value.replace(',', '.')),
      parseFloat(this.$maximumInput.value.replace(',', '.')),
    ]);

    this.updateLabels();
  }

  private updateLabels(): void {
    this.$minimumLabel.innerHTML = this.$minimumInput.value;
    this.$maximumLabel.innerHTML = this.$maximumInput.value;
  }
};
